import { useQuery } from '@apollo/client';
import classNames from 'classnames';
import { QUERY_GET_RELEASE_PRODUCT, QUERY_GET_SLUG_RELEASE_PRODUCT } from '~/components/SneakerRelease/graphql';
import { SneakLaunchResponse } from '~/services/sneaker-release/sneaker-release.type';
import 'swiper/css/effect-coverflow';

// import required modules
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useState } from 'react';
type Props = {
    brandName?: string;
    brandCode?: string;
};

const SneakerBrandIntroduction = ({ brandCode, brandName }: Props) => {
    return (
        <section className="w-auto grid grid-cols-12 gap-4 px-2 md:px-8 mb-4">
            <div className="lg:col-span-5 col-span-full place-content-center">
                <h1
                    className={classNames(
                        'text-[10.5rem] lg:text-[20.5rem] tracking-[-0.03em] leading lg:leading-[1.5] font-bold text-black mb-4 text-center'
                    )}
                >
                    <div className="capitalize">{brandName || brandCode?.replace('-', ' ')}</div>
                </h1>
                {/*  */}
            </div>
            {/* <div className="col-span-full lg:col-span-7 md:ml-14 place-content-center">
                <>
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: true
                        }}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false
                        }}
                        pagination={true}
                        modules={[EffectCoverflow, Autoplay]}
                        onSlideChange={(swiper) => {
                            setItemActive(swiper.activeIndex);
                        }}
                        // className="mySwiper"
                    >
                        {fetchReleaseProduct?.getReleaseProducts?.items?.map((item) => {
                            return (
                                <SwiperSlide style={{ alignContent: 'center', background: item.pageTheme }}>
                                    <img
                                        src={item?.thumbnail?.root}
                                        style={{
                                            width: 'auto',
                                            height: '500px',
                                            objectFit: 'contain',
                                            margin: 'auto'
                                        }}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </>
            </div> */}
        </section>
    );
};

export default SneakerBrandIntroduction;
